var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgVisaCard = function SvgVisaCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 27,
    viewBox: "0 0 80 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    d: "M34.6666 25.6539H28.186L32.2394 0.49939H38.7196L34.6666 25.6539Z",
    fill: "#2566AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M58.1591 1.11426C56.8809 0.605297 54.8535 0.043335 52.3466 0.043335C45.9468 0.043335 41.4402 3.46846 41.4125 8.36535C41.3594 11.9783 44.6392 13.985 47.0922 15.1896C49.5994 16.4206 50.4517 17.2241 50.4517 18.3213C50.4262 20.0065 48.4257 20.7833 46.5599 20.7833C43.9726 20.7833 42.5862 20.3828 40.4794 19.4452L39.6261 19.0433L38.7192 24.69C40.2392 25.385 43.0395 26.0017 45.9468 26.0287C52.7467 26.0287 57.1736 22.6566 57.2261 17.4382C57.2519 14.5747 55.5201 12.3805 51.7863 10.5876C49.5197 9.43663 48.1316 8.66056 48.1316 7.48293C48.1582 6.41235 49.3056 5.31582 51.8643 5.31582C53.9711 5.26211 55.519 5.77037 56.6917 6.27898L57.2778 6.54609L58.1591 1.11426Z",
    fill: "#2566AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M66.7723 16.7426C67.306 15.2975 69.3597 9.70454 69.3597 9.70454C69.3327 9.75824 69.8923 8.23277 70.2123 7.29628L70.6652 9.46375C70.6652 9.46375 71.8924 15.4849 72.1589 16.7426C71.1461 16.7426 68.0524 16.7426 66.7723 16.7426ZM74.7718 0.49939H69.7591C68.2132 0.49939 67.0388 0.953938 66.3719 2.58647L56.7458 25.6536H63.5457C63.5457 25.6536 64.6652 22.5489 64.9058 21.8803C65.6518 21.8803 72.2667 21.8803 73.2263 21.8803C73.4124 22.7634 73.9996 25.6536 73.9996 25.6536H79.9999L74.7718 0.49939Z",
    fill: "#2566AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M22.7734 0.49939L16.4268 17.6524L15.7332 14.1736C14.5599 10.1594 10.88 5.79819 6.77344 3.62966L12.5867 25.6273H19.4397L29.626 0.49939H22.7734Z",
    fill: "#2566AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M10.5333 0.49939H0.106668L0 1.00764C8.13339 3.09508 13.52 8.12677 15.7331 14.1746L13.4665 2.61386C13.0933 1.00729 11.9465 0.552385 10.5333 0.49939Z",
    fill: "#E6A540"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgVisaCard);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/visa-card.cacae434fa71e11d039cca7843ab39dc.svg";